import styled from 'styled-components';


const Root = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
`;

const HeaderLayout = styled.div`
	flex: 0 0 auto;
	position: relative;
	width: 100%;
	height: auto;
	min-height: 70px;
	display: flex;
`;

const ContentLayout = styled.div`
	flex: 1 0 auto;
	position: relative;
	width: 100%;
	height: 100%;
`;

const MainLayout = styled.div`
	flex: 1 1 auto;
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: column nowrap;
	justify-content: space-between;
`;

const SidebarLayout = styled.div`
	position: relative;
	width: 264px;
	height: 100%;
	display: flex;
	flex-flow: column nowrap;
	justify-content: space-between;
`;


export {
	Root,
	HeaderLayout,
	ContentLayout,
	MainLayout,
	SidebarLayout,
}
